import moment from "moment";
import { REPORTS_DOCTOR_COMMISSION_PROGRAM } from "../../framework/tab/tabUtilsConstants";

export const columnDefs = [
  {
    headerName: "Doctor Commission Program Code",
    field: "doctorCommissionId",
    locked: true,
    hide: false,
    cellClass: "custom-ag-cell-link",
    width: 200,
    suppressMovable: true,
  },
  {
    headerName: "Doctor Commission Program Name",
    field: "doctorCommissionName",
    locked: true,
    hide: false,
    width: 300,
  },
  {
    headerName: "Manufacturer Group Id",
    field: "manufacturerGroupId",
    locked: false,
    hide: true,
    width: 200,
  },
  {
    headerName: "Manufacturer Group",
    field: "manufacturerGroup",
    locked: true,
    hide: false,
    width: 250,
  },
  {
    headerName: "Medicine Form",
    field: "medicineForm",
    locked: true,
    hide: false,
    width: 200,
  },
  {
    headerName: "Doctor Type",
    field: "doctorType",
    locked: true,
    hide: false,
    width: 150,
  },
  {
    headerName: "Program Start Date",
    field: "startDate",
    locked: true,
    hide: false,
    width: 180,
  },
  {
    headerName: "Program End Date",
    field: "endDate",
    locked: true,
    hide: false,
    width: 180,
  },
  {
    headerName: "Branches",
    field: "branchCode",
    locked: false,
    hide: false,
    width: 350,
  },
  {
    headerName: "Status",
    field: "deleted",
    locked: false,
    hide: false,
    width: 120,
  },
  {
    headerName: "Created Date",
    field: "createdTime",
    locked: false,
    hide: false,
    width: 180,
  },
  {
    headerName: "Created By",
    field: "createdBy",
    locked: false,
    hide: false,
    width: 150,
  },
  {
    headerName: "Updated Date",
    field: "updatedTime",
    locked: false,
    hide: false,
    width: 180,
  },
  {
    headerName: "Updated By",
    field: "updatedBy",
    locked: false,
    hide: false,
    width: 150,
  },
  {
    headerName: "Company",
    field: "company",
    locked: false,
    hide: false,
    width: 150,
  },
];
export const columnDefsFunctions = {
  manufacturerGroup: {
    valueGetter: (params) => {
      return params.data?.manufacturerGroup?.name || "";
    },
  },
  startDate: {
    valueFormatter: (params) => {
      return moment(`${params.value}`).format("DD/MM/YYYY");
    },
  },
  endDate: {
    valueFormatter: (params) => {
      return moment(`${params.value}`).format("DD/MM/YYYY");
    },
  },
  createdTime: {
    valueFormatter: (params) => {
      return moment(`${params.value}`).format("DD/MM/YYYY");
    },
  },
  updatedTime: {
    valueFormatter: (params) => {
      return moment(`${params.value}`).format("DD/MM/YYYY");
    },
  },
  deleted: {
    valueFormatter: (params) => {
      return params.value === true ? "INACTIVE" : "ACTIVE";
    },
    filterValueGetter: (params) => {
      return params.data?.deleted === true ? "INACTIVE" : "ACTIVE";
    },
    cellStyle: (params) => {
      return {
        borderRight: "1px solid #a0a0a0",
        ...(params.value === true && { color: "red" }),
        ...(params.value === false && { color: "green" }),
      };
    },
  },
};

export const initial_state_doctor_commission_program_report = {
  type: REPORTS_DOCTOR_COMMISSION_PROGRAM,
  label: "Doctor Commission Program Report",
  allowMultipleTabs: false,
};
